<div class="budget-line-item-dropdown-container">
  <app-search-input
    class="mx-2 mb-1"
    [verticalSpacing]="false"
    label=""
    placeholder="Search Budget Line Items..."
    (searchText)="searchText($event)"
  ></app-search-input>
  <ng-scrollbar class="std-scrollbar rows-wrapper" orientation="vertical" appearance="native">
    <div class="table-wrapper">
      <div class="row">
        <span class="row-title">Select Budget Line </span>
        <span
          [ngClass]="{ invisible: commitmentType !== COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER }"
          class="row-title"
          >Contract Assigned</span
        >
        <span class="row-title">Budget</span>
        <span class="row-title">Commit</span>
        <span class="row-title">Balance</span>
      </div>
      @for (budgetLineItem of displayedLineItems; track budgetLineItem; let i = $index) {
        <div class="row cursor-default">
          <div
            (click)="
              optionSelected.emit({ action: 'select', item: budgetLineItem, name: budgetLineItem.name, index: i })
            "
            class="pointer-cursor"
            [ngClass]="{ disabled: (budgetLineItem.id | containsValue: disabledLineItems) }"
          >
            <app-faded-text>
              <div class="whitespace-nowrap text-size_m font-semibold">{{ budgetLineItem.name }}</div>
              <div class="whitespace-nowrap text-size_s">
                {{ budgetLineItem.division }}.{{ budgetLineItem.cost_type }}
              </div>
            </app-faded-text>
          </div>
          <span
            class="icon"
            [ngClass]="{
              'icon-approved': budgetLineItem.contractApproved,
              invisible: commitmentType !== COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER,
            }"
          ></span>
          <div class="bl-column" [ngClass]="{ negative: (budgetLineItem?.current_budget ?? 0) < 0 }">
            {{ budgetLineItem?.current_budget | money: 'shortWithParentheses' }}
          </div>
          <div class="bl-column" [ngClass]="{ negative: (budgetLineItem?.committed ?? 0) < 0 }">
            {{ budgetLineItem?.committed | money: 'shortWithParentheses' }}
          </div>
          <div
            class="bl-column"
            [ngClass]="{ negative: (budgetLineItem?.current_budget ?? 0) - (budgetLineItem?.committed ?? 0) < 0 }"
          >
            {{
              (budgetLineItem?.current_budget ?? 0) - (budgetLineItem?.committed ?? 0) | money: 'shortWithParentheses'
            }}
          </div>
        </div>
      }
    </div>
  </ng-scrollbar>
  <div class="buttons-container">
    <button class="btn-small ml-4 mb-2 dropdown-button" (click)="optionSelected.emit({ action: 'delete' })">
      Delete Budget Line Item
    </button>
  </div>
</div>
